import React, { useState } from "react";
import { useSelector } from "react-redux";
import { PermmisionPostsTypeEnum } from "../../../../../../models/PermmisionPostsTypeEnum";
import { onKeyDown } from "../../../../../../service";
import { DynamicMessageTypeEnum } from "../../../../../lms-shared/models/DynamicMessageTypeEnum";
import DynamicMessage from "../../../../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import AutoComplete from "./AutoComplete";
import classes from './SpecificFriends.module.css';


const SpecificFriends = ({ show, setShow, friendsList, setFriendsList, choosenFriends, setChoosenFriends, beenSharedBefore, changeSpecificFriends }) => {


    const { direction, texts } = useSelector((state) => state.translate);

    const [message, setMessage] = useState();

    function removeFriend(f) {
        const _choosenFriends = { ...choosenFriends, [f.permissionMask]: choosenFriends[f.permissionMask].filter(x => x.targetObjectId !== f.targetObjectId) }
        if (!_choosenFriends.RunnerOnly.length && !_choosenFriends.RunnerAndCode.length) {
            setMessage(<DynamicMessage
                type={DynamicMessageTypeEnum.Error}
                title={texts.Error}
                content={texts.MessageContentSharesIsNull}
                confirmFunc={() => { setMessage(null) }} />)
        }
        else {
            setChoosenFriends(_choosenFriends);
            setFriendsList(friendsList.concat(f));
            if (beenSharedBefore) {
                changeSpecificFriends(_choosenFriends);
            }
        }
    }

    return (
        <div className={`${classes.SpecificFriends} ${beenSharedBefore ? classes.SpecificFriendsEdit : ''}`}>
            <div className={classes.SpecificFriendsHeader}>
                <hr className={`${classes.HeaderHr} ${beenSharedBefore ? classes.HeaderHrEdit : ''}`} />
                <div className={`${classes.CollapseIcon} ${show ? '' : classes.OpenIcon}`} onClick={() => setShow(!show)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShow(!show))}></div>
            </div>
            {show ?
                <div className={classes.SpecificFriendsContainer}>
                    <AutoComplete friendsList={friendsList} setFriendsList={setFriendsList} setChoosenFriends={setChoosenFriends} choosenFriends={choosenFriends} changeSpecificFriends={changeSpecificFriends} beenSharedBefore={beenSharedBefore} />
                    <div className={`${classes[direction]} ${classes.ChoosenFriends}`}>
                        {Object.keys(PermmisionPostsTypeEnum).map(type => (
                            <div key={type} className={classes.AllFriendsContainer}>
                                <div>{texts[type]}:</div>
                                <div className={classes.AllFriendsWrapper}>
                                    <div className={classes.AllFriends}>
                                        {choosenFriends[type].map(f => (
                                            <div key={f.targetObjectId} className={classes.Friend}>
                                                <div>{f.name}</div>
                                                <div className={classes.RemoveFriend} onClick={() => removeFriend(f)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => removeFriend(f))}>x</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div> : ''}
            {message}
        </div>
    )
}

export default SpecificFriends;